import React, { Component } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ZoomLightbox from '../stateless/zoom-lightbox';
import { deactivatePopup } from '../../state/actions/image-zoom-popup';

/**
 * @class Modal
 *
 * @description
 * Class for a showing a modal questions on screen.
 *
 * @example
 * <Modal />
 */
@connect(
	state => ({
		image: state.imageZoomPopup.image,
		isZoomPopupClosed: state.imageZoomPopup.isZoomPopupClosed
	}),
	dispatch => ({
		deactivatePopup: () => {
			dispatch(deactivatePopup())
		}
	})
)
export default class ImageZoomPopup extends Component {

	static propTypes = {
		image: PropTypes.string,
		isZoomPopupClosed: PropTypes.bool
	}

	/**
	 * @description
	 * checks the state of the lightbox and returns it
	 * if it should be visible.
	 *
	 * @returns {ReactElement | null}
	 */
	getLightboxState () {
		const { isZoomPopupClosed, image, deactivatePopup } = this.props;

		let lightbox = null;

		if (!isZoomPopupClosed && image) {
			lightbox = (
				<ZoomLightbox
					key={'zoom-lightbox'}
					image={image}
					deactivatePopup={deactivatePopup}
				/>
			)
		}

		return lightbox;
	}

	/**
	 *
	 * @returns {ReactElement}
	 */
	render () {
		return (
			<CSSTransitionGroup
				className="fade-fast"
				transitionName="fade-fast"
				transitionLeaveTimeout={400}
				transitionEnterTimeout={400}
			>
				{this.getLightboxState()}
			</CSSTransitionGroup>
		);
	}
}
